const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl) {
    return envUrl;
  }
  // Fallback to localhost only in development
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5001';
  }
  // In production, warn if API URL is not set
  console.error('⚠️ REACT_APP_API_URL is not set! Frontend will not be able to connect to backend.');
  return 'http://localhost:5001'; // Fallback, but will fail in production
};

export const config = {
  // Backend API URL - points directly to Flask server
  // Development: http://localhost:5001
  // Production: MUST set REACT_APP_API_URL environment variable (e.g., https://your-app.onrender.com)
  API_URL: getApiUrl(),
  SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL || '',
  SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY || '',
};
